// 基本的フォームパーツ

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { connect, useDispatch, useSelector } from 'react-redux';
import * as mui from '../common/materialUi';
import * as comMod from '../../commonModule';
import { getUser, findDeepPath } from '../../commonModule';
import TextField from '@material-ui/core/TextField';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import AddIcon from '@material-ui/icons/Add';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteIcon from '@material-ui/icons/Delete';
import Favorite from '@material-ui/icons/Favorite';
import FavoriteBorder from '@material-ui/icons/FavoriteBorder';
import { common } from '@material-ui/core/colors';
import { Tune } from '@material-ui/icons';
import {
  useStyles, sw, selectStyle, ChkBoxGp, SelectGp, TextGP
} from './FormPartsCommon'
import Autocomplete from '@material-ui/lab/Autocomplete';
import { endPoint } from '../../Actions'
import axios from 'axios';
import { set } from 'js-cookie';
import { IconButton } from '@material-ui/core';

// 加算が記述される位置により渡されるオブジェクトの構造が違う
// 想定されるオブジェクトの形に対応しフォームにデフォルト値を返す
const getDef = (obj, name, uid = '', did = '') => {
  uid = (uid === undefined || uid === null) ? '' : uid;
  did = (did === undefined || did === null) ? '' : did;
  if (typeof did === 'object') did = comMod.convDid(did);
  // scheduleから検索する場合
  let rt = comMod.findDeepPath(
    obj, ['value', uid, did, name]
  );
  // templateから検索する場合
  if (rt === null || rt === undefined) {
    rt = comMod.findDeepPath(obj, ['value', name]);
  }
  return rt;
}

// 定員
export const Teiin = (props) => {
  const classes = useStyles();
  const nameJp = '定員';
  let def = getDef(props, nameJp, props.uid, props.did);
  def = (def === null || undefined) ? 0 : def;
  const [val, setval] = useState(def);
  const [err, seterr] = useState(false);
  const [errMsg, seterrMsg] = useState('');
  const handleBlur = (e) => {
    const han = comMod.convHankaku(e.currentTarget.value);
    setval(han);
    if (isNaN(han)) {
      seterr(true);
      seterrMsg('数値を入力してください。');
    }
    else if (!han) {
      seterr(true);
      seterrMsg('入力必須項目です。');
    }
    else {
      seterr(false);
      seterrMsg('');
    }
  }
  const handleChange = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setval(e.currentTarget.value);
  };

  const [noticeopen, setnoticeopen] = useState(false);
  const discriptionClick = (e) => {
    setnoticeopen(true);
  }
  const Discription = () => (
    <span className='discription' onClick={discriptionClick}>
      <span className="main">
        定員は10人以下、11人以上20人以下、21人以上で請求できる単位数が変わります。
      </span>
      <span className="more">
        もっと詳しい説明。もっと詳しい説明。もっと詳しい説明。
        もっと詳しい説明。もっと詳しい説明。もっと詳しい説明。
      </span>
    </span>
  )
  return (
    <div className={"aFormPartsWrapper Teiin " + props.size}>
      <TeiinFormParts
        value={val}
        err={err}
        errMsg={errMsg}
        nameJp={nameJp}
        onChange={(e) => handleChange(e)}
        onBlur={(e) => handleBlur(e)}
        size={props.size}
        disabled={props.disabled}
      />
      <Discription />
      <mui.NoticeDialog
        className={classes.noticeDialog}
        title={nameJp}
        noticeopen={noticeopen}
        setnoticeopen={setnoticeopen}
        Content={Discription}
      />
    </div>

  )
}

const TeiinFormParts = (props) => {
  const classes = useStyles();
  const size = props.size;
  // sizeに応じたクラス名を求める
  const classList = ['tfLargeNum', 'tfMiddleNum'];
  const cls = selectStyle(props.size, classList);

  return (
    <div className={classes[cls]}>
      <TextField
        id="teiinInput"
        name={props.nameJp}
        required
        label={props.nameJp}
        value={props.value}
        onChange={(e) => props.onChange(e)}
        onBlur={e => props.onBlur(e)}
        error={props.err}
        helperText={props.errMsg}
        disabled={!props.disabled}
      />
    </div>
  )
}


// 地域区分
export const ChiikiKubun = (props) => {
  const classes = useStyles();
  const nameJp = '地域区分';
  let def = getDef(props, nameJp, props.uid, props.did);
  def = (def === null || undefined) ? '' : def;
  const [val, setval] = useState(def);
  const handleChange = (e) => {
    setval(e.currentTarget.value)
  }
  const [noticeopen, setnoticeopen] = useState(false);
  const discriptionClick = (e) => {
    setnoticeopen(true);
  }

  const Discription = () => (
    <span className='discription' onClick={discriptionClick}>
      <span className="main">
        地域区分とは地域間における人件費の差を勘案して、保険費用の配分を調整するために設けられた区分です。指定された区分を選択してください。
      </span>
      <span className="more">
        もっと詳しい説明。もっと詳しい説明。もっと詳しい説明。
        もっと詳しい説明。もっと詳しい説明。もっと詳しい説明。
      </span>
    </span>
  )
  const opts = [
    '１級地',
    '２級地',
    '３級地',
    '４級地',
    '５級地',
    '６級地',
    '７級地',
    'その他',
  ]
  return (
    <>
      <div className={"aFormPartsWrapper ChiikiKubun " + props.size}>
        <SelectGp
          onChange={e => handleChange(e)}
          nameJp={nameJp}
          value={val}
          size={props.size}
          opts={opts}
          disabled={props.disabled}

        />
        <Discription />
        <mui.NoticeDialog
          className={classes.noticeDialog}
          title={nameJp}
          noticeopen={noticeopen}
          setnoticeopen={setnoticeopen}
          Content={Discription}

        />
      </div>
    </>

  )
}

// 時刻入力
export const TimeInput = (props) => {
  const classes = useStyles();
  let def = getDef(props, props.name, props.uid, props.did);
  def = (def === null || undefined) ? props.def : def;
  def = (def === null || undefined) ? "00:00" : def;
  const [val, setval] = useState(def);
  const [err, seterr] = useState(false);
  const [errMsg, seterrMsg] = useState('');
  // バリデーション
  const handleBlur = (e) => {
    let val = comMod.convHankaku(e.currentTarget.value);
    // 正規表現のパターン定義
    const ptn = '^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$'
    // コロンの確認追加
    if (val.indexOf(':') === -1) {
      val = val.substr(0, val.length - 2) + ':' + val.substr(-2);
    }
    // 長さが短かったら0パディング
    val = (val.length < 5) ? '0' + val : val;
    setval(val);
    if (val.search(ptn) === -1) {
      seterr(true);
      seterrMsg('時刻が必要です。');
    }
    else if (!val) {
      seterr(true);
      seterrMsg('入力必須です。');
    }
    else {
      seterr(false);
      seterrMsg('');
    }
  }
  const handleChange = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setval(e.currentTarget.value);
  };
  return (
    <div className={"aFormPartsWrapper TimeInput " + props.size}>
      {!props.noLabel &&
        <TimeInputFormParts
          value={val}
          err={err}
          name={props.name}
          label={props.label}
          onChange={(e) => handleChange(e)}
          onBlur={(e) => handleBlur(e)}
          size={props.size}
          disabled={props.disabled}
          required={props.required}
        />
      }
      {props.noLabel &&
        <TimeInputFormPartsNolabel
          value={val}
          err={err}
          name={props.name}
          onChange={(e) => handleChange(e)}
          onBlur={(e) => handleBlur(e)}
          size={props.size}
          disabled={props.disabled}
          required={props.required}
        />
      }
    </div>
  )
}

const TimeInputFormParts = (props) => {
  const classes = useStyles();
  const size = props.size;
  // sizeに応じたクラス名を求める
  const classList = ['tfLargeNum', 'tfMiddleNum'];
  const cls = selectStyle(props.size, classList);

  return (
    <div className={classes[cls]}>
      <TextField
        // id="teiinInput"
        name={props.name}
        required={props.required}
        label={(props.label) ? props.label : props.name}
        value={props.value}
        onChange={(e) => props.onChange(e)}
        onBlur={e => props.onBlur(e)}
        error={props.err}
        helperText={props.errMsg}
        disabled={props.disabled}
      />
    </div>
  )
}

const TimeInputFormPartsNolabel = (props) => {
  const classes = useStyles();
  const size = props.size;
  // sizeに応じたクラス名を求める
  const classList = ['tfLargeNum', 'tfMiddleNum'];
  const cls = selectStyle(props.size, classList);

  return (
    <div className={classes[cls]}>
      <Input
        name={props.name}
        required={props.required}
        value={props.value}
        onChange={(e) => props.onChange(e)}
        onBlur={e => props.onBlur(e)}
        error={props.err}
        disabled={props.disabled}
      />
    </div>
  )
}


export const HolidayOrNot = (props) => {
  let def = getDef(props, props.name, props.uid, props.did);
  def = (def === null || undefined) ? "" : def;
  const [val, setval] = useState(def);
  const handleChange = (e) => {
    setval(e.currentTarget.value)
  }
  const opts = [
    { value: 0, label: '平日利用', class: '' },
    { value: 1, label: '休日利用', class: 'holiday' },
  ];
  return (
    <SelectGp
      onChange={e => handleChange(e)}
      name={props.name}
      label={props.label}
      value={val}
      size={props.size}
      opts={opts}
      disabled={props.disabled}
    />
  )
}
// 実費指定用のチェックボックス
export const ActualCostCheckBox = (props) => {
  const actualCostListDef = useSelector(state => state.config.actualCostList);
  // リストの初期値をpropsからも設定できるようにする
  const actualCostList = (props.actualCostList)
    ? props.actualCostList : actualCostListDef;
  const name = 'actualCost';
  const label = '実費'
  let def = getDef(props, name, props.uid, props.did);
  // 実費項目のオブジェクトを配列化
  // [['おやつ', 100], ['教材費', 100], ['その他', 100],]
  def = (!def) ? [] : def;
  const lst = comMod.objToArray(actualCostList);
  // 配列化された項目に対してチェックの有無を格納する
  // [['おやつ', 100, true], ['教材費', 100, false], ['その他', 100, false],]

  const chkBoxLst = lst.map(e => {
    const c = (Object.keys(def).indexOf(e[0]) > -1) ? true : false;
    return ({ name: e[0], price: e[1], checked: c });
  });
  const [val, setval] = useState([...chkBoxLst]);
  useEffect(() => {
    setval([...chkBoxLst])
  }, [actualCostList]);
  const handleChange = (ev) => {
    const tmp = val.map(e => {
      return (
        (ev.target.name === e.name) ? { ...e, checked: ev.target.checked } : e
      )
    });
    setval(tmp);
  };
  const priceTotalFunc = () => {
    let total = 0;
    val.map(_ => {
      if (_.checked) total += parseInt(_.price);
    });
    return total;
  }
  const priceTotal = priceTotalFunc();
  const chkBoxes = val.map((e, i) => {
    return (
      <FormControlLabel
        key={i}
        control={
          <Checkbox
            checked={e.checked}
            onChange={handleChange}
            name={e.name}
            price={e.price}
            color="primary"
            value="actualCost"
          />
        }
        label={e.name}
      />
    )
  });
  return (<>
    <div className='aFormPartsWrapper acturalCostCheckBox'>
      {chkBoxes}
      <span className='priceLabel'>{priceTotal} 円</span>
    </div>
  </>);
}


// 送迎の入力
export const Transfer = (props) => {
  const name = props.name;
  const label = props.label;
  let def = getDef(props, 'transfer', props.uid, props.did);
  def = (def === null || def === undefined) ? '' : def;
  // defはこの場合、配列なので処理
  def = (props.name === 'pickup' && def) ? def[0] : def[1];
  const [val, setval] = useState(def);
  const handleChange = (e) => {
    setval(e.currentTarget.value)
  }
  // オプションのリストをステイトから取得
  const opts = useSelector(state => state.config.transferList);
  // オプションリストをusers etcから取得
  const users = useSelector(state => state.users);
  const thisUser = getUser(props.uid, users);
  // if (findDeepPath(thisUser, 'etc.destList')){
  //   thisUser.etc.destList.map(e=>{
  //     opts.push(e);
  //   });
  // }
  // オプションリストを所属から取得
  if (thisUser.belongs1 && opts.indexOf(thisUser.belongs1) === -1) {
    opts.push(thisUser.belongs1);
  }
  if (thisUser.belongs2 && opts.indexOf(thisUser.belongs2) === -1) {
    opts.push(thisUser.belongs2);
  }
  return (
    <>
      <div className={"aFormPartsWrapper transfer " + props.size}>
        <SelectGp
          onChange={e => handleChange(e)}
          name={name}
          value={val}
          size={props.size}
          opts={opts}
          disabled={props.disabled}
          label={label}
          nullLabel='なし' // 空白文字を選択するときのラベル指定
        />
      </div>
    </>
  )
}

export const WeeksChkBox = (props) => {
  const { name, value, ...other } = props;
  const labels = [
    '日', '月', '火', '水', '木', '金', '土',
  ];
  const [check, setcheck] = useState(new Array(7).fill(false));
  const handleChange = (i, e) => {
    const t = Object.assign([], check);
    t[i] = e.target.checked;
    setcheck(t);
  }
  const classes = useStyles();
  const chkbox = labels.map((e, i) => {
    return (
      <FormControlLabel key={i} className={classes.formControlChkBox}
        control={
          <Checkbox
            // style={{ width: '20px', height: '20px' }}
            // icon={<CheckBoxOutlineBlankIcon style={{ fontSize: '20px' }} />}
            // checkedIcon={<CheckBoxIcon style={{ fontSize: '20px' }} />}
            icon={<CheckBoxOutlineBlankIcon />}
            checkedIcon={<CheckBoxIcon />}
            onChange={(e) => handleChange(i, e)}
            // name={name}
            value={name}
            name={e}
            index={i}
            checked={check[i]}
          // color={props.color}
          />
        }
        label={e}
      />
    )
  });
  return (chkbox);
}

// 住所入力
// 郵便番号と住所をセットで提供する
export const PostalAndAddress = (props) => {
  const { defPostal, defAddr1, defAddr2, required } = props;
  const def_Postal = (defPostal) ? defPostal : '';
  const def_city = (defAddr1) ? defAddr1 : '';
  const def_address = (defAddr2) ? defAddr2 : '';
  const [postal, setpostal] = useState(def_Postal);
  const [city, setcity] = useState(def_city);
  const [address, setaddress] = useState(def_address);
  const [errPostal, seterrPostal] = useState(false);
  const [errCity, seterrCity] = useState(false);
  const [erraddress, seterraddress] = useState(false);
  const [errMsgPostal, seterrMsgPostal] = useState(false);
  const [errMsgcity, seterrMsgcity] = useState(false);
  const [errMsgaddress, seterrMsgaddress] = useState(false);
  // useEffect用に確定した郵便番号を用意するハイフン無し
  const [postalfixed, setpostalfixed] = useState('');
  // 郵便番号が書き換えられたかどうかのフラグ
  const [postaledited, setpostaledited] = useState(false);

  // useEffectで発火
  // apiから郵便番号で住所を得る
  async function fetchAddressFromZip() {
    try {
      const url = endPoint + '?a=zip&postal=' + postalfixed;
      const res = await axios.get(url);
      console.log(res);
      if (res.status === 400) {
        throw res.message;
      }
      else if (res.data.results === null) {
        throw '指定の郵便番号が見つかりません。';
      }
      const r = res.data.results[0];
      if (!r.submsg) {
        setcity(r.address1 + r.address2 + r.address3);
      }
      // 代替検索を行ったとき
      else {
        setcity(r.address1 + r.address2);
        seterrMsgcity(r.submsg);
      }
    }
    catch (e) {
      console.log("postal get error.")
      seterrMsgcity(e);
      seterrCity(true);
    }

  }
  useEffect(() => {
    // エラーがなくて値がセットされていて修正されているとき
    if (!errPostal && postalfixed && postaledited) {
      fetchAddressFromZip();
    }
  }, [postalfixed]);

  const handleChange = (e) => {
    if (e.target.name === 'postal') {
      setpostal(e.target.value);
      setpostaledited(true);
    }
    if (e.target.name === 'city') setcity(e.target.value);
    if (e.target.name === 'address') setaddress(e.target.value);
  }

  const handleFocus = (e) => {
    // postalがfocusでeditフラグをオフにする
    if (e.target.name === 'postal') {
      setpostaledited(false);
    }
  }

  const handleBlur = (e) => {
    const target = e.target;
    const value = target.value;
    if (target.name === 'postal') {
      let v = comMod.convHankaku(value);
      v = v.replace('-', '');
      if (isNaN(v) || v.length !== 7) {
        seterrPostal(true);
        seterrMsgPostal('7桁の数値が必要です');
      }
      else {
        seterrPostal(false);
        seterrMsgPostal('');
        setpostal(v.substr(0, 3) + '-' + v.substr(3, 4));
        setpostalfixed(v);
      }
    }
    else {
      const han = comMod.convHankaku(value);
      if (target.name === 'city') setcity(han);
      if (target.name === 'address' && han) {
        setaddress(han);
        seterraddress(false);
        seterrMsgaddress('');
      }
    }
  }

  return (<>
    <div className="sFormaParts postal">
      <TextGP
        name='postal' label='郵便番号'
        value={postal} required={required}
        cls='tfMiddle'
        onChange={(e) => handleChange(e)}
        onBlur={(e) => handleBlur(e)}
        onFocus={(e) => handleFocus(e)}
        err={errPostal} errMsg={errMsgPostal}
      />
    </div>
    <div className="sFormaParts address">
      <TextGP
        name='city' label='住所１'
        cls='tfMiddle4XL'
        value={city} required={required}
        onChange={(e) => handleChange(e)}
        onBlur={(e) => handleBlur(e)}
        err={errCity} errMsg={errMsgcity}
      />
    </div>
    <div className="sFormaParts address">
      <TextGP
        name='address' label='住所２'
        cls='tfMiddle4XL'
        value={address} required={required}
        onChange={(e) => handleChange(e)}
        onBlur={(e) => handleBlur(e)}
        err={erraddress} errMsg={errMsgaddress}
      />
    </div>
  </>)
}

// 名前を入力させる
// kanaはboolen かな入力に限定するかどうか
// 姓と名の2つのフィールドを出力する
export const NameInput = (props) => {
  const {
    nameLname, nameFname, labelLname, labelFname, kana, required, def,
  } = props;
  const def_ = (def) ? def : '';
  const sname = def_.split(' ');
  const [lname, setlname] = useState(sname[0]);
  const [fname, setfname] = useState(sname[1]);
  const [err0, seterr0] = useState(false);
  const [errMsg0, seterrMsg0] = useState('');
  const [err1, seterr1] = useState(false);
  const [errMsg1, seterrMsg1] = useState('');

  const handleChange = (e) => {
    if (e.target.name === nameLname) setlname(e.target.value);
    if (e.target.name === nameFname) setfname(e.target.value);
  }
  const handleBlur = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    // 入力フィールドによって関数名にエイリアス
    let seterr, seterrMsg, setval;
    if (name === nameLname) {
      seterr = seterr0;
      seterrMsg = seterrMsg0;
      setval = setlname;
    }
    else {
      seterr = seterr1;
      seterrMsg = seterrMsg1;
      setval = setfname;
    }
    if (!value && required) {
      seterr(true);
      seterrMsg('入力必須項目です。');
    }
    else {
      seterr(false);
      seterrMsg('');
    }
    // かなのチェック
    if (!comMod.convKanaToHiraAndChk(value).result && kana && value) {
      seterr(true);
      seterrMsg('かなを入力してください。');
    }
    // かなの変換
    if (comMod.convKanaToHiraAndChk(value).result && kana && value) {
      seterr(false);
      seterrMsg('');
      setval(comMod.convKanaToHiraAndChk(value).str);
    }
  }
  return (<>
    <div className="sFormaParts name">
      <TextGP
        name={nameLname} label={labelLname}
        value={lname} required={required}
        cls='tfMiddle'
        onChange={(e) => handleChange(e)}
        onBlur={(e) => handleBlur(e)}
        err={err0} errMsg={errMsg0}
      />
    </div>
    <div className="sFormaParts name">
      <TextGP
        name={nameFname} label={labelFname}
        cls='tfMiddle'
        value={fname} required={required}
        onChange={(e) => handleChange(e)}
        onBlur={(e) => handleBlur(e)}
        err={err1} errMsg={errMsg1}
      />
    </div>
  </>)
}

// 障害種別
export const UserType = (props) => {
  const { def, ...other } = props;
  const name = 'type';
  const label = '障害児種別';
  const def_ = (def) ? def : '';

  const [val, setval] = useState(def_);
  const [err, seterr] = useState(false);
  const [errMsg, seterrMsg] = useState('');
  const handleChange = (e) => {
    setval(e.currentTarget.value);
  }
  const handleBlur = (e) => {
    const v = e.currentTarget.value;
    if (!v) {
      seterr(true);
      seterrMsg('選択してください。');
    }
    else {
      seterr(false);
      seterrMsg('');
    }
  }


  const opts = ['障害児', '重症心身障害児'];
  return (
    <div className="sFormaParts usertype">
      <SelectGp
        onChange={e => handleChange(e)}
        onBlur={e => handleBlur(e)}
        styleUse='tfMiddleL'
        name={name}
        value={val}
        size={'large'}
        opts={opts}
        err={err}
        errMsg={errMsg}
        disabled={props.disabled}
        label={label}
        required
      />
    </div>
  )
}

// サービス種別
export const ServiceType = (props) => {
  const { def, ...other } = props;
  const name = 'service';
  const label = 'サービス種別';
  const def_ = (def) ? def : '';

  const [val, setval] = useState(def_);
  const [err, seterr] = useState(false);
  const [errMsg, seterrMsg] = useState('');
  const handleChange = (e) => {
    setval(e.currentTarget.value);
  }
  const handleBlur = (e) => {
    const v = e.currentTarget.value;
    if (!v) {
      seterr(true);
      seterrMsg('選択してください。');
    }
    else {
      seterr(false);
      seterrMsg('');
    }
  }


  const opts = ['放課後等デイサービス', '児童発達支援'];
  return (
    <div className="sFormaParts service">
      <SelectGp
        onChange={e => handleChange(e)}
        onBlur={e => handleBlur(e)}
        styleUse='fcMiddleL'
        name={name}
        value={val}
        size={'large'}
        opts={opts}
        err={err}
        errMsg={errMsg}
        disabled={props.disabled}
        label={label}
        required
      />
    </div>
  )
}

// 事業所番号
export const JiNumber = (props) => {
  const { def, ...other } = props;
  const name = 'jino';
  const label = '事業所番号';
  const def_ = (def) ? def : '';

  const [val, setval] = useState(def_);
  const [err, seterr] = useState(false);
  const [errMsg, seterrMsg] = useState('');
  const handleChange = (e) => {
    setval(e.currentTarget.value);
  }
  const handleBlur = (e) => {
    const han = comMod.convHankaku(e.currentTarget.value);
    setval(han);
    if (isNaN(han)) {
      seterr(true);
      seterrMsg('数値が必要です。');
    }
    else if (!han) {
      seterr(true);
      seterrMsg('入力必須項目です。');
    }
    else if (han.length != 10) {
      seterr(true);
      seterrMsg('番号は10桁です。');
    }
    else {
      seterr(false);
      seterrMsg('');
    }
  }

  return (
    <div className="sFormaParts jino">
      <TextGP
        onChange={e => handleChange(e)}
        onBlur={e => handleBlur(e)}
        cls={'tfMiddle'}
        name={name}
        value={val}
        err={err}
        errMsg={errMsg}
        label={label}
        required
      />
    </div>
  )
}

// 事業所名
export const Bname = (props) => {
  const { def, ...other } = props;
  const name = 'bname';
  const label = '事業所名';
  const def_ = (def) ? def : '';

  const [val, setval] = useState(def_);
  const [err, seterr] = useState(false);
  const [errMsg, seterrMsg] = useState('');
  const handleChange = (e) => {
    setval(e.currentTarget.value);
  }
  const handleBlur = (e) => {
    const v = comMod.convHankaku(e.currentTarget.value);
    setval(v);
    if (!v) {
      seterr(true);
      seterrMsg('入力必須項目です。');
    }
    else if (v.length > 30) {
      seterr(true);
      seterrMsg('事業所名は30文字までです');
    }
    else {
      seterr(false);
      seterrMsg('');
    }
  }

  return (
    <div className="sFormaParts bname">
      <TextGP
        onChange={e => handleChange(e)}
        onBlur={e => handleBlur(e)}
        cls={'tfMiddle4XL'}
        name={name}
        value={val}
        err={err}
        errMsg={errMsg}
        label={label}
        required
      />
    </div>
  )
}

// 事業所名
export const Sbname = (props) => {
  const { def, ...other } = props;
  const name = 'sbname';
  const label = '事業所略称';
  const def_ = (def) ? def : '';

  const [val, setval] = useState(def_);
  const [err, seterr] = useState(false);
  const [errMsg, seterrMsg] = useState('');
  const handleChange = (e) => {
    setval(e.currentTarget.value);
  }
  const handleBlur = (e) => {
    const v = comMod.convHankaku(e.currentTarget.value);
    setval(v);
    if (!v) {
      seterr(true);
      seterrMsg('入力必須項目です。');
    }
    else if (v.length > 10) {
      seterr(true);
      seterrMsg('略称は10文字までです');
    }
    // else if (v.length > 4) {
    //   seterr(false);
    //   seterrMsg('4文字程度がお薦めです');
    // }
    else {
      seterr(false);
      seterrMsg('');
    }
  }

  return (
    <div className="sFormaParts sbname">
      <TextGP
        onChange={e => handleChange(e)}
        onBlur={e => handleBlur(e)}
        cls={'tfMiddleXL'}
        name={name}
        value={val}
        err={err}
        errMsg={errMsg}
        label={label}
        required
      />
    </div>
  )
}



// 被保険者ナンバー
export const HihokenNo = (props) => {
  const { def, uid, ...other } = props;
  const name = 'hno';
  const label = '被保険者番号';
  const def_ = (def) ? def : '';
  const users = useSelector(state => state.users);
  const [val, setval] = useState(def_);
  const [err, seterr] = useState(false);
  const [errMsg, seterrMsg] = useState('仮登録は数字3桁');
  const handleChange = (e) => {
    setval(e.currentTarget.value);
  }
  const handleBlur = (e) => {
    const han = comMod.convHankaku(e.currentTarget.value);
    setval(han);
    // 保険番号重複確認
    let existHno;
    // uid未設定の場合。追加のときは未設定で来るはず
    if (!uid) {
      const c = users.find(f => f.hno === han);
      existHno = c ? true : false;
    }
    // uid設定済み。修正モード
    else {
      const uidn = uid.replace(/[^0-9]/g, '');
      const c = users.find(f => f.hno === han && f.uid !== uidn);
      existHno = c ? true : false;
    }
    if (isNaN(han)) {
      seterr(true);
      seterrMsg('数値が必要です。');
    }
    else if (!han) {
      seterr(true);
      seterrMsg('入力必須項目です。');
    }
    else if (han.length != 10 && han.length != 3) {
      seterr(true);
      seterrMsg('番号は10桁です。');
    }
    else if (existHno) {
      seterr(true);
      seterrMsg('保険番号が重複してます。');
    }
    else {
      seterr(false);
      seterrMsg('');
      if (han.length === 3) {
        seterrMsg('仮登録します');
      }
    }
  }

  return (
    <div className="sFormaParts hno">
      <TextGP
        onChange={e => handleChange(e)}
        onBlur={e => handleBlur(e)}
        cls={'tfMiddle'}
        name={name}
        value={val}
        err={err}
        errMsg={errMsg}
        label={label}
        required
      />
    </div>
  )
}

// 契約支給量
export const Volume = (props) => {
  const { def, ...other } = props;
  const name = 'volume';
  const label = '契約支給量';
  const def_ = (def) ? def : '';

  const [val, setval] = useState(def_);
  const [err, seterr] = useState(false);
  const [errMsg, seterrMsg] = useState('');
  const handleChange = (e) => {
    setval(e.currentTarget.value);
  }
  const handleBlur = (e) => {
    const han = comMod.convHankaku(e.currentTarget.value);
    setval(han);
    if (isNaN(han)) {
      seterr(true);
      seterrMsg('数値を入力してください。');
    }
    else if (!han) {
      seterr(true);
      seterrMsg('入力必須項目です。');
    }
    else if (han === 0 || han > 30) {
      seterr(true);
      seterrMsg('無効な数値です。');
    }
    else {
      seterr(false);
      seterrMsg('');
    }
  }
  return (
    <div className="sFormaParts volume">
      <TextGP
        onChange={e => handleChange(e)}
        onBlur={e => handleBlur(e)}
        cls={'tfMiddle'}
        name={name}
        value={val}
        err={err}
        errMsg={errMsg}
        label={label}
        required
      />
    </div>
  )
}

// 上限額
export const PriceLimit = (props) => {
  const { def, ...other } = props;
  const name = 'priceLimit';
  const label = '上限額';
  const def_ = (def) ? def : '';

  const [val, setval] = useState(def_);
  const [err, seterr] = useState(false);
  const [errMsg, seterrMsg] = useState('');
  const handleChange = (e) => {
    setval(e.currentTarget.value);
  }
  const handleBlur = (e) => {
    const han = comMod.convHankaku(e.currentTarget.value);
    setval(han);
    if (isNaN(han)) {
      seterr(true);
      seterrMsg('数値を入力してください。');
    }
    else if (!han) {
      seterr(true);
      seterrMsg('入力必須項目です。');
    }
    else if (han === 0 || han > 100000) {
      seterr(true);
      seterrMsg('無効な数値です。');
    }
    else {
      seterr(false);
      seterrMsg('');
    }
  }
  return (
    <div className="sFormaParts priceLimit">
      <TextGP
        onChange={e => handleChange(e)}
        onBlur={e => handleBlur(e)}
        cls={'tfMiddle'}
        name={name}
        value={val}
        size={'large'}
        err={err}
        errMsg={errMsg}
        label={label}
        required
      />
    </div>
  )
}

// 契約書記入欄番号
export const ContractLineNo = (props) => {
  const { def, ...other } = props;
  const name = 'lineNo';
  const label = '記入欄番号';
  const def_ = (def) ? def : '';

  const [val, setval] = useState(def_);
  const [err, seterr] = useState(false);
  const [errMsg, seterrMsg] = useState('');
  const handleChange = (e) => {
    setval(e.currentTarget.value);
  }
  const handleBlur = (e) => {
    const han = comMod.convHankaku(e.currentTarget.value);
    setval(han);
    if (isNaN(han)) {
      seterr(true);
      seterrMsg('数値を入力してください。');
    }
    else if (!han) {
      seterr(true);
      seterrMsg('入力必須項目です。');
    }
    else if (han === 0 || han > 100000) {
      seterr(true);
      seterrMsg('無効な数値です。');
    }
    else {
      seterr(false);
      seterrMsg('');
    }
  }
  return (
    <div className="sFormaParts priceLimit">
      <TextGP
        onChange={e => handleChange(e)}
        onBlur={e => handleBlur(e)}
        cls={'tfMiddle'}
        name={name}
        value={val}
        size={'large'}
        err={err}
        errMsg={errMsg}
        label={label}
        required
      />
    </div>
  )
}



// 支給市区町村
// オートコンプリートとテキストフィールドを提供する
// すでに入力されている市区町村は市区町村名で市区町村番号を特定して
// テキストフィールドに出力、readonyにする
// 新規の場合はテキストフィールドに番号を入力する
// defは配列で渡される
export const Scity = (props) => {
  const { label, name, labelNo, nameNo, def, ...other } = props;
  const def_ = (def) ? def : ['', ''];
  const [scity, setscity] = useState(def_[0]);
  const [scityNo, setscityNo] = useState(def_[1]);
  const [scityNoErr, setscityNoErr] = useState(false);
  const [scityNoText, setscityNoText] = useState('');
  const [scityNoDisabled, setscityNoDisabled] = useState(true);
  const classes = useStyles();
  // 支給市区町村のリスト
  const users = useSelector(state => state.users);
  const sCityiesSet = new Set();
  users.map(e => {
    sCityiesSet.add(e.scity); // 一意な市区町村名のみ作成する
  });
  // 一意な市区町村名に市区町村番号を付与する
  const scityList = Array.from(sCityiesSet).map(e => {
    const scno = users.find(f => f.scity === e).scity_no;
    return ({ scity: e, scity_no: scno });
  });
  const handleChange = (e) => {
    setscityNo(e.currentTarget.value);
  }

  // チェンジイベントはliに発生するときとテキストフィールドに発生するとき
  // 両方ある。共通の処理をまとめる
  const numberSet = (v) => {
    const f = scityList.filter(e => e.scity === v);
    const num = (f.length) ? f[0].scity_no : '';
    setscityNo(num);  // 取得できた市区町村番号をstateにセット
    // 市区町村番号が取得できたらdisabledにする 
    setscityNoDisabled((num) ? true : false);
    setscityNoErr(false);
    setscityNoText('');
  }

  const handleAcChange = (e) => {
    const value = e.currentTarget.value
    setscity(value);
    numberSet(value);
  }
  const handleLiChange = (e, v) => {
    numberSet(v);
  }
  const handleTxBlur = (e) => {
    const han = comMod.convHankaku(e.currentTarget.value);
    if (isNaN(han) || han.length != 6) {
      setscityNoErr(true);
      setscityNoText('6桁の数字が必要です。');
    }
    else {
      setscityNoErr(false);
      setscityNoText('');

    }
    setscityNo(han);
  }
  return (<>
    <div className={"sFormaParts scity " + classes.tfMiddleXL}>
      <Autocomplete
        freeSolo
        options={scityList.map(e => e.scity)}
        value={def_[0]}
        onChange={(e, v) => handleLiChange(e, v)}
        renderInput={(params) => (
          <TextField
            {...params} id='rte98d' label={label} name={name}
            onChange={(e) => handleAcChange(e)}
          />
        )}
      />
    </div>
    <div className={'sFormaParts scity ' + classes.tfMiddle}>
      <TextField
        name={nameNo}
        label={labelNo}
        value={scityNo || ''}
        onChange={(e) => handleChange(e)}
        onBlur={e => handleTxBlur(e)}
        disabled={scityNoDisabled}
        error={scityNoErr}
        helperText={scityNoText}
        required
      />
    </div>
  </>)

}

// 管理区分
export const KanriType = (props) => {
  const { def, ...other } = props;
  const name = 'kanri_type';
  const label = '管理・協力';
  const def_ = (def) ? def : '';
  const [val, setval] = useState(def_);
  // const [err, seterr] = useState(false);
  // const [errMsg, seterrMsg] = useState('');
  const handleChange = (e) => {
    setval(e.currentTarget.value);
  }
  const handleBlur = (e) => {
    // const v = e.currentTarget.value;
    // if (!v) {
    //   seterr(true);
    //   seterrMsg('選択してください。');
    // }
    // else {
    //   seterr(false);
    //   seterrMsg('');
    // }
    return false;
  }


  const opts = ['管理事業所', '協力事業所'];
  return (
    <div className="sFormaParts kanriType">
      <SelectGp
        onChange={e => handleChange(e)}
        onBlur={e => handleBlur(e)}
        styleUse='fcMiddle'
        name={name}
        value={val}
        opts={opts}
        // err={err}
        // errMsg={errMsg}
        label={label}
        required
      />
    </div>
  )
}


// 上限管理結果入力
export const KanriKekka = (props) => {
  const { def, ...other } = props;
  const name = 'kanriKekka';
  const label = '上限管理結果';
  const def_ = (def) ? def : '';
  const [val, setval] = useState(def_);
  // const [err, seterr] = useState(false);
  // const [errMsg, seterrMsg] = useState('');
  const handleChange = (e) => {
    setval(e.currentTarget.value);
  }
  const handleBlur = (e) => {
    // const v = e.currentTarget.value;
    // if (!v) {
    //   seterr(true);
    //   seterrMsg('選択してください。');
    // }
    // else {
    //   seterr(false);
    //   seterrMsg('');
    // }
    return false;
  }

  // “1”管理事業所で利用者負担額を充当したため、他事業所では発生しない。
  //  協力事業所の場合、他事業所で管理されると1を入れる？
  // “2”利用者負担額の合計額が、負担上限月額以下のため、調整事務は行わない。
  // “3”利用者負担額の合計額が、負担上限月額を超過するため、調整した。 

  const opts = [
    { value: 1, label: '1:管理事業所が充当', class: '' },
    { value: 2, label: '2:上限内調整不要', class: '' },
    { value: 3, label: '3:管理事業所が調整', class: '' },
  ];
  return (
    <div className="sFormaParts kanriType">
      <SelectGp
        onChange={e => handleChange(e)}
        onBlur={e => handleBlur(e)}
        styleUse='fcMiddleL'
        name={name}
        value={val}
        opts={opts}
        // err={err}
        // errMsg={errMsg}
        label={label}
        required
      />
    </div>
  )
}



// 日付入力
export const DateInput = (props) => {
  const { name, label, required, def, cls, wrapperStyle, ...other } = props;
  const def_ = (def) ? def : '';
  const cls_ = (cls) ? cls : 'tfMiddleL';
  // .sFormaPartsに追加されるスタイル
  const wStyle = (wrapperStyle) ? wrapperStyle : {};
  const [val, setval] = useState(def_);
  const [err, seterr] = useState(false);
  const [errMsg, seterrMsg] = useState('');
  const handleChange = (e) => {
    setval(e.currentTarget.value);
  }
  const handleBlur = (e) => {
    const r = comMod.parseDate(e.currentTarget.value);
    setval(comMod.convHankaku(e.currentTarget.value));
    if (required && !r.result) {
      seterr(true);
      seterrMsg('日付が必要です');
    }
    else if (required && !e.currentTarget.value) {
      seterr(true);
      seterrMsg('入力必須項目です');

    }
    else if (r.result) {
      const zp = comMod.zp;
      seterr(false);
      // 0000-00-00を入力すると変な値が帰ってくるので阻止
      if (r.date.y === 1899 && r.date.m == 11 && r.date.d == 30) {
        setval('0000-00-00');
        seterrMsg('');
      }
      else {
        const d = r.date.y + '-' + zp(r.date.m, 2) + '-' + zp(r.date.d, 2);
        setval(d);
        seterrMsg('西暦' + r.date.y + '年 ' + r.date.wr.full);

      }
    }
  }
  return (
    <div className="sFormaParts volume" style={wStyle}>
      <TextGP
        onChange={e => handleChange(e)}
        onBlur={e => handleBlur(e)}
        cls={cls_}
        name={name}
        value={val}
        err={err}
        errMsg={errMsg}
        label={label}
        required={required}
      />
    </div>
  )
}

// メールアドレス入力
export const MailInput = (props) => {
  const { name, label, required, def, ...other } = props;
  const def_ = (def) ? def : '';
  const [val, setval] = useState(def_);
  const [err, seterr] = useState(false);
  const [errMsg, seterrMsg] = useState('');
  const handleChange = (e) => {
    setval(e.currentTarget.value);
  }
  const handleBlur = (e) => {
    const mail = e.currentTarget.value;
    const chk = comMod.isMailAddress(mail);
    setval(comMod.convHankaku(e.currentTarget.value));
    if (!mail && required) {
      seterr(true);
      seterrMsg('入力必須項目です。');
    }
    else if (!chk) {
      seterr(true);
      seterrMsg('メールアドレスが不正です');
    }
    else {
      seterr(false);
      seterrMsg('');
    }
  }
  return (
    <div className="sFormaParts volume">
      <TextGP
        onChange={e => handleChange(e)}
        onBlur={e => handleBlur(e)}
        cls={'tfMiddleXXL'}
        name={name}
        value={val}
        err={err}
        errMsg={errMsg}
        label={label}
        required={required}
      />
    </div>
  )
}

// 電話番号入力
export const PhoneInput = (props) => {
  const { name, label, required, def, ...other } = props;
  const def_ = (def) ? def : '';
  const [val, setval] = useState(def_);
  const [err, seterr] = useState(false);
  const [errMsg, seterrMsg] = useState('');
  const handleChange = (e) => {
    setval(e.currentTarget.value);
  }
  const handleBlur = (e) => {
    let phone = e.currentTarget.value;
    const rt = comMod.formatTelNum(phone);
    if (!phone && required) {
      seterr(true);
      seterrMsg('入力必須項目です。');
    }
    else if (!rt.result) {
      seterr(true);
      seterrMsg('番号が不正です');
    }
    else {
      seterr(false);
      seterrMsg('');
      setval(rt.format);
    }
  }
  console.log('err, errMsg, required', err, errMsg, required);
  return (
    <div className="sFormaParts volume">
      <TextGP
        onChange={e => handleChange(e)}
        onBlur={e => handleBlur(e)}
        cls={'tfMiddle'}
        name={name}
        value={val}
        err={err}
        errMsg={errMsg}
        label={label}
        required={required}
      />
    </div>
  )
}

// 教室
// 所属の入力と一緒だけどオプションリストを
// このコンポーネントから作成する予定
export const ClassRoom = (props) => {
  const classes = useStyles();
  const users = useSelector(state => state.users);
  const clSet = new Set();
  users.map((e) => {
    if (e.classroom) clSet.add(e.classroom);
  });
  const options = Array.from(clSet);

  const { def, ...other } = props;
  const def_ = (def) ? def : '';
  const [val, setval] = useState(def_);
  const handleChange = (e) => {
    setval(e.currentTarget.value);
  }
  const handleBlur = (ev) => {
    const v = comMod.convHankaku(ev.currentTarget.value);
    setval(v);
  }
  return (
    <div className="sFormaParts volume">
      <Autocomplete
        freeSolo
        options={options.map(e => e)}
        value={val}
        renderInput={(params) => (
          <TextField className={classes.tfMiddleXL}
            {...params}
            label={'教室'}
            name={'classroom'}
            onChange={e => handleChange(e)}
            onBlur={e => handleBlur(e)}
            value={val}
          />
        )}
      />
    </div>
  )
}


// 所属
export const Belongs = (props) => {
  const classes = useStyles();
  const { name, label, options, def, ...other } = props;
  const def_ = (def) ? def : '';
  const [val, setval] = useState(def_);
  const handleChange = (e) => {
    setval(e.currentTarget.value);
  }
  return (
    <div className="sFormaParts volume">
      <Autocomplete
        freeSolo
        options={options.map(e => e)}
        value={val}
        renderInput={(params) => (
          <TextField className={classes.tfMiddleXL}
            {...params}
            label={label} name={name}
            onChange={e => handleChange(e)}
            value={val}
            name={name}
          />
        )}
      />
    </div>
  )
}

export const TestFreeSolo = (props) => {
  return (
    <div style={{ width: 300 }}>
      <Autocomplete
        id="free-solo-demo"
        freeSolo
        options={props.options}
        renderInput={(params) => (
          <TextField {...params} label="freeSolo" margin="normal" />
        )}
      />
    </div>
  )
}

// 他事業所
// 上限管理等で利用する他事業所の情報を入力する
// オートコンプリートとテキストフィールドを提供する
// すでに入力されている他事業所番号は
// テキストフィールドに出力、readonyにする
// 新規の場合はテキストフィールドに番号を入力する
// defは配列で渡される
export const OtherOffice = (props) => {
  const { 
    label, name, labelNo, nameNo, def,disabled, // updateUpperLimitEnable,
    officeNames, setOfficeNames, ndx, // 上位コンポーネントで使うセッターとインデックス
    ...other 
  } = props;
  const def_ = (def) ? def : ['', '',];
  const [val, setval] = useState(def_[0]);
  const [valNo, setvalNo] = useState(def_[1]);
  const [valNoErr, setvalNoErr] = useState(false);
  const [valNoText, setvalNoText] = useState('');
  const [valNoDisabled, setvalNoDisabled] = useState(true);
  const classes = useStyles();
  // 他事業所のリスト
  const users = useSelector(state => state.users);
  const officeSet = new Set();
  // ユニークな事業所名のリストを作成する
  users.map(e => {
    if (e.etc) {
      if (e.etc.協力事業所) {
        e.etc.協力事業所.map(f => {
          officeSet.add(f.name);
        });
      }
      if (e.etc.管理事業所) {
        e.etc.管理事業所.map(f => {
          officeSet.add(f.name);
        });
      }
    }
  });
  // 登録されている全ての事業所を配列化
  const tmpOffice = [];
  users.map(e => {
    if (e.etc) {
      if (e.etc.協力事業所) {
        e.etc.協力事業所.map(f => {
          tmpOffice.push({ name: f.name, no: f.no });
        });
      }
      if (e.etc.管理事業所) {
        e.etc.管理事業所.map(f => {
          tmpOffice.push({ name: f.name, no: f.no });
        });
      }

    }
  })
  // 事業所名リストから事業所番号を付加して{name, no}の配列を作成する
  const officeList = [];
  Array.from(officeSet).map(e => {
    officeList.push(tmpOffice.find(f => f.name === e));
  });
  const handleChange = (e) => {
    setvalNo(e.currentTarget.value);
    const t = officeNames;
    t[ndx] = (e.currentTarget.value);
    setOfficeNames(t);
  }

  // チェンジイベントはliに発生するときとテキストフィールドに発生するとき
  // 両方ある。共通の処理をまとめる
  const numberSet = (v) => {
    const f = officeList.filter(e => e.name === v);
    const num = (f.length) ? f[0].no : '';
    setvalNo(num);  // 取得できた市区町村番号をstateにセット
    // 市区町村番号が取得できたらdisabledにする 
    setvalNoDisabled((num) ? true : false);
    setvalNoErr(false);
    setvalNoText('');
  }

  const handleAcChange = (e) => {
    const value = e.currentTarget.value
    setval(value);
    numberSet(value);
  }
  const handleAcBlur = (e) => {
    const value = e.currentTarget.value
    numberSet(value);
  }
  const handleLiChange = (e, v) => {
    numberSet(v);
  }
  const handleTxBlur = (e) => {
    const han = comMod.convHankaku(e.currentTarget.value);
    if (isNaN(han) || han.length != 10) {
      setvalNoErr(true);
      setvalNoText('10桁の数字が必要です。');
    }
    else {
      setvalNoErr(false);
      setvalNoText('');
    }
    setvalNo(han);
  }
  return (<>
    <div className={"sFormaParts otherOffice " + classes.tfMiddleXL}>
      <Autocomplete
        freeSolo
        options={officeList.map(e => e.name)}
        value={def_[0]}
        onChange={(e, v) => handleLiChange(e, v)}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params} id='rte99d' label={label} name={name}
            onChange={(e) => handleAcChange(e)}
            disabled={disabled}
            onBlur={(e) => handleAcBlur(e)}
          />
        )}
      />
    </div>
    <div className={'sFormaParts otherOffice ' + classes.tfMiddle}>
      <TextField
        name={nameNo}
        label={labelNo}
        value={valNo || ''}
        onChange={(e) => handleChange(e)}
        onBlur={e => handleTxBlur(e)}
        disabled={valNoDisabled || disabled}
        error={valNoErr}
        helperText={valNoText}
        required
      />
    </div>
  </>)
}

// 上限管理の配分種別
export const HaibunSyubetu = (props) => {
  const { def, ...other } = props;
  const name = '上限管理配分種別';
  const label = '上限管理配分種別';
  const def_ = (def) ? def : '';

  const [val, setval] = useState(def_);
  const [err, seterr] = useState(false);
  const [errMsg, seterrMsg] = useState('');
  const handleChange = (e) => {
    setval(e.currentTarget.value);
  }
  const handleBlur = (e) => {
    const v = e.currentTarget.value;
    if (!v) {
      seterr(true);
      seterrMsg('選択してください。');
    }
    else {
      seterr(false);
      seterrMsg('');
    }
  }
  const opts = ['自社最大', '最多利用最大', /*'等分'*/];
  return (
    <div className="sFormaParts usertype">
      <SelectGp
        onChange={e => handleChange(e)}
        onBlur={e => handleBlur(e)}
        styleUse='tfMiddleL'
        name={name}
        value={val}
        size={'large'}
        opts={opts}
        err={err}
        errMsg={errMsg}
        disabled={props.disabled}
        label={label}
        required
      />
    </div>
  )
}

// 数値入力全般
export const NumInputGP = (props) => {
  // def:デフォルト値 name: label: upper:上限 lower:下限 
  // cls:useStyleで使われるクラス名。
  const { 
    def, name, label, upper, lower, cls, required, disabled, ...other 
  } = props;
  const def_ = (def) ? def : '';
  const lower_ = (lower) ? lower : 0;
  const upper_ = (upper) ? upper : 0;
  const cls_ = (cls) ? cls : 'tfMiddle';

  const [val, setval] = useState(def_);
  const [err, seterr] = useState(false);
  const [errMsg, seterrMsg] = useState('');
  const handleChange = (e) => {
    setval(e.currentTarget.value);
  }
  const handleBlur = (e) => {
    const han = comMod.convHankaku(e.currentTarget.value);
    setval(han);
    if (isNaN(han)) {
      seterr(true);
      seterrMsg('数値を入力してください。');
    }
    else if (!han && required) {
      seterr(true);
      seterrMsg('入力必須項目です。');
    }
    else if (han < lower_) {
      seterr(true);
      seterrMsg('無効な数値です。');
    }
    else if (han > upper_ && upper_) {
      seterr(true);
      seterrMsg('無効な数値です。');
    }
    else {
      seterr(false);
      seterrMsg('');
    }
  }
  return (
    <div className="sFormaParts volume">
      <TextGP
        onChange={e => handleChange(e)}
        onBlur={e => handleBlur(e)}
        cls={cls_}
        name={name}
        value={val}
        err={err}
        errMsg={errMsg}
        label={label}
        disabled={disabled}
        required={required}
      />
    </div>
  )
}

// 稼働率計算方法の設定
export const SetOccupancyCalc = (props) => {
  const name = 'configOccupancyRate';
  const label = '稼働率計算方法';
  const size = (props.size) ? props.size : 'large';
  let etc = useSelector(state => state.com.etc);
  etc = (etc) ? etc : {};
  let def = etc[name];
  def = (def === null || def === undefined) ? '' : def;
  const [val, setval] = useState(def);
  const handleChange = (e) => {
    setval(e.currentTarget.value)
  }
  const Discription = () => (
    <span className='discription'>
      <span className="main">
        稼働率計算に休業日、休校日を含めるかどうかを設定します。
      </span>
    </span>
  )


  // オプションのリストをステイトから取得
  const opts = [
    '休業日を含めて稼働率計算',
    '休業・休校を含めず稼働率計算'
  ];
  return (
    <>
      <div className={"aFormPartsWrapper occurate " + size}>
        <SelectGp
          onChange={e => handleChange(e)}
          name={name}
          value={val}
          size={size}
          opts={opts}
          disabled={props.disabled}
          label={label}
          nullLabel='休業日を含めず稼働率計算' // 空白文字を選択するときのラベル指定
        />
        <Discription />
      </div>
    </>
  )
}

export const SetUsersSort = (props) => {
  const name = 'setUsersSort';
  const label = 'ユーザー表示並び順';
  const size = (props.size) ? props.size : 'large';
  const { sortOrder, setsortOrder, ...rest } = props;
  // let etc = useSelector(state => state.com.etc);
  // etc = (etc) ? etc : {};
  // let def = etc[name];
  // def = (def === null || def === undefined) ? 0 : def;
  const handleChange = (e) => {
    setsortOrder(e.currentTarget.value)
  }
  const Discription = () => (
    <span className='discription'>
      <span className="main">
        ユーザーの並び順を設定します。設定した並び順はユーザー一覧や各種帳票など色々な場所に反映されます。
      </span>
    </span>
  )
  const opts = [
    { value: 0, label: '変更なし', class: '' },
    { value: 1, label: '学齢順に並べる', class: '' },
    { value: 2, label: '利用開始順に並べる', class: '' },
    { value: 3, label: '所属・学校順に並べる', class: '' },
    { value: 4, label: '50音順に並べる', class: '' },
  ];
  return (
    <>
      <div className={"aFormPartsWrapper usersort " + size}>
        <SelectGp
          onChange={e => handleChange(e)}
          name={name}
          value={sortOrder}
          size={size}
          opts={opts}
          disabled={props.disabled}
          label={label}
          hidenull
        // nullLabel='学齢順に並べる' // 空白文字を選択するときのラベル指定
        />
        <Discription />
      </div>
    </>
  )
}

// 送迎先のリストを編集する
// ユーザーごとの送迎先を編集 使わない予定
// 単純テキストボックスになっているがfreesoloのコードも残してある
export const TransferList = (props) => {
  const classes = useStyles();
  // 引数は親コンポーネントで定義されたstate
  const { destList, setDestList, uid, } = props;
  const [newItem, setNewItem] = useState('');
  const [newItemErr, setNewItemErr] = useState(false);
  const [newItemText, setNewItemText] = useState('');
  const users = useSelector(state => state.users);
  const thisUser = comMod.getUser(uid, users);
  useEffect(() => {
    if (comMod.findDeepPath(thisUser, 'etc.destList') !== null) {
      setDestList(thisUser.etc.destList);
    }
  }, [thisUser]);
  // const users = useSelector(state=>state.users);
  // 仮の行き先リスト
  // setDestList(['校門', '裏庭', '駅前',]);
  // 仮の入力候補
  // const options = ['ほがらか小学校', 'やすらぎ小学校', 'のほほん小学校',];
  // 他ユーザーも含めて送迎先に設定されている目的地を列挙する
  const destListSet = new Set();
  users.map(e => {
    if (!e.etc) return false;
    if (!e.etc.destList) return false;
    // console.log('guwa', e.etc.destList);
    e.etc.destList.map(f => {
      destListSet.add(f);
    });
  });
  const options = Array.from(destListSet);
  const handleChange = (ev) => {
    setNewItem(ev.target.value);
  }
  const handeleAddClick = (ev) => {
    // 未入力チェック
    if (!newItem) {
      setNewItemErr(true);
      setNewItemText('未入力です。');
      return false;
    }
    // 重複チェック
    if (destList.indexOf(newItem) > -1) {
      setNewItemErr(true);
      setNewItemText('登録済みです。');
      return false;
    }
    setNewItemErr(false);
    setNewItemText('');

    const t = [...destList];
    t.push(newItem);
    setDestList(t);
    setNewItem('');
  }
  const handleDeleteClick = (ev) => {
    const t = [...destList];
    const name = ev.currentTarget.name;
    const i = t.findIndex(e => e === name);
    t.splice(i, 1);
    setDestList(t);
  }
  const handleLichange = (e, v) => {
    console.log(v);
    setNewItem(v);
  }

  const destItemsDisp = destList.map((e, i) => {
    return (
      <div className='destItem' key={i}>
        <span>{e}</span>
        <IconButton className={classes.smallIconButton}
          onClick={(ev) => handleDeleteClick(ev)}
          name={e}
        >
          <DeleteIcon />
        </IconButton>
      </div>
    )
  });
  return (<>
    <div className='cntRow'>
      {destItemsDisp}
    </div>
    <div className='cntRow'>
      <div className={"destList " + classes.tfMiddleL}>
        {/* <Autocomplete
          freeSolo
          options={options}
          value={newItem}
          onChange={(e, v) => handleLichange(e, v)}
          renderInput={(params) => (
            <TextField
              {...params} id='rte98d' label={'送迎場所'} name={'dest'}
              onChange={(e) => handleChange(e)}
              error={newItemErr}
              value={newItem}
              helperText={newItemText}
            />
          )}
        /> */}
        <TextGP
          label={'送迎場所'} name={'dest'}
          onChange={(e) => handleChange(e)}
          error={newItemErr}
          onBlur={() => { return null }}
          value={newItem}
          helperText={newItemText}
        />
      </div>
      <IconButton
        onClick={handeleAddClick}
      >
        <AddCircleIcon color='primary' />
      </IconButton>
    </div>
  </>)
}
// 送迎先設定グローバル用
// state.config.transferListにdispatchする用
export const TransferListGlobal = (props) => {
  const classes = useStyles();
  // 引数は親コンポーネントで定義されたstate
  const { destList, setDestList, } = props;
  const [newItem, setNewItem] = useState('');
  const [newItemErr, setNewItemErr] = useState(false);
  const [newItemText, setNewItemText] = useState('');
  const config = useSelector(state => state.config);
  // setDestList(config.transferList);
  const handleChange = (ev) => {
    setNewItem(ev.target.value);
  }
  const handeleAddClick = (ev) => {
    // 未入力チェック
    if (!newItem) {
      setNewItemErr(true);
      setNewItemText('未入力です。');
      return false;
    }
    // 重複チェック
    if (destList.indexOf(newItem) > -1) {
      setNewItemErr(true);
      setNewItemText('登録済みです。');
      return false;
    }
    setNewItemErr(false);
    setNewItemText('');

    // const t = [...destList];
    // t.push(newItem);
    setDestList([...destList, newItem]);
    setNewItem('');
  }
  const handleDeleteClick = (ev) => {
    const t = [...destList];
    const name = ev.currentTarget.name;
    const i = t.findIndex(e => e === name);
    t.splice(i, 1);
    setDestList(t);
  }

  const destItemsDisp = destList.map((e, i) => {
    return (
      <div className='destItem' key={i}>
        <span>{e}</span>
        <IconButton className={classes.smallIconButton}
          onClick={(ev) => handleDeleteClick(ev)}
          name={e}
        >
          <DeleteIcon />
        </IconButton>
      </div>
    )
  });
  return (<>
    <div className='cntRow'>
      {destItemsDisp}
    </div>
    <div className='cntRow'>
      <div className={"destList " + classes.tfMiddleL}>
        <TextGP
          label={'送迎場所'} name={'dest'}
          onChange={(e) => handleChange(e)}
          error={newItemErr}
          onBlur={() => { return null }}
          value={newItem}
          helperText={newItemText}
        />
      </div>
      <IconButton
        onClick={handeleAddClick}
      >
        <AddCircleIcon color='primary' />
      </IconButton>
    </div>
  </>)
}


// ファイル名プレフィクス
// ダウンロードするファイル名の先頭文字を指定する
export const FilenamePreFix = (props) => {
  const name = 'fprefix';
  const label = 'ファイル先頭文字';
  const size = (props.size) ? props.size : 'large';
  let def = useSelector(state => state.com.fprefix);
  def = (def === null || def === undefined) ? '' : def;
  const [val, setval] = useState(def);
  const [err, setErr] = useState(false);
  const [errText, setErrText] = useState('');

  const handleChange = (ev) => {
    setval(ev.currentTarget.value)
  }
  // バリデーション
  const handleBlur = (ev) => {
    const v = ev.currentTarget.value;
    if (!v) {
      setErr(true);
      setErrText('入力必須項目');
    }
    else if (!v.match(/^[0-9a-zA-Z]*$/)) {
      setErr(true);
      setErrText('半角英数字のみ');

    }
    else if (v.length > 7) {
      setErr(true);
      setErrText('8文字以内');
    }
    else {
      setErr(false);
      setErrText('');
    }
  }
  const Discription = () => (
    <span className='discription'>
      <span className="main">
        帳票などをダウンロードするための事業所ごとのファイル名先頭文字を設定します。2文字から6文字程度の英数字を
        入力します。ダウンロードしたファイルで事業所をわかりやすくするためです。<br />
        例）横浜事業所→ykhm など。
      </span>
    </span>
  )

  return (
    <>
      <div className={"aFormPartsWrapper filenamePreFix " + size}>
        <TextGP
          label={label} name={name}
          onChange={(e) => handleChange(e)}
          error={err}
          onBlur={(e) => handleBlur(e)}
          value={val}
          helperText={errText}
        />
        <Discription />
      </div>
    </>
  )
}
